import React from "react";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import LcvCampaignSelect from "../shared/LcvCampaignSelect";
import LcvDealerReportGrid from "./views/LcvDealerReportGrid";

export default function LcvDealerReportWrapper() {
     return (
          <>
               <MainLeftTitle title="LCV Dealer Report" />

               <LcvCampaignSelect />

               <LcvDealerReportGrid />
          </>
     );
}
